// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-secondary: #000000;
  --color-accent: #ffffff;
  --color-neutral: #ffffff;
  --color-text: #000000;
}

.contact-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.contact-modal {
  background: white;
  border-radius: 1.5rem;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.contact-modal-simple {
  max-width: 700px;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: rgba(0, 0, 0, 0.05);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--color-text);
  z-index: 10;
}

.modal-close:hover {
  background: rgba(0, 0, 0, 0.1);
  transform: rotate(90deg);
}

.modal-header {
  padding: 3rem 3rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, var(--color-neutral) 0%, #fff 100%);
}

.modal-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
}

.modal-header p {
  color: var(--color-primary);
  font-size: 1rem;
  opacity: 0.9;
}

.modal-form {
  padding: 2rem 3rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-text);
  font-size: 0.95rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid rgba(55, 65, 81, 0.15);
  border-radius: 0.5rem;
  font-size: 1rem;
  font-family: inherit;
  transition: all 0.2s ease;
  background: white;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-secondary);
  box-shadow: 0 0 0 3px rgba(170, 97, 58, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-success {
  background: #10b981;
  color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 600;
}

.submit-error {
  background: #ef4444;
  color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 600;
}

.modal-submit-btn {
  width: 100%;
  background: var(--color-secondary);
  color: var(--color-neutral);
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.02em;
}

.modal-submit-btn:hover:not(:disabled) {
  background: var(--color-primary);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(55, 65, 81, 0.25);
}

.modal-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-contact-info {
  padding: 2rem 3rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: linear-gradient(to bottom, #fff 0%, var(--color-neutral) 100%);
  border-top: 1px solid rgba(55, 65, 81, 0.1);
}

.contact-info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--color-primary);
  font-size: 0.95rem;
}

.contact-info-item svg {
  color: var(--color-secondary);
  flex-shrink: 0;
}

.modal-contact-info-large {
  padding: 2rem 3rem 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.contact-info-card {
  background: linear-gradient(135deg, var(--color-neutral) 0%, #fff 100%);
  border: 2px solid rgba(55, 65, 81, 0.1);
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.contact-info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(55, 65, 81, 0.15);
  border-color: var(--color-secondary);
}

.contact-info-card:last-child {
  cursor: default;
}

.contact-info-card:last-child:hover {
  transform: none;
}

.contact-icon-large {
  width: 70px;
  height: 70px;
  background: var(--color-secondary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  transition: all 0.3s ease;
}

.contact-info-card:hover .contact-icon-large {
  background: var(--color-primary);
  transform: scale(1.1);
}

.contact-info-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text);
  margin-bottom: 0.75rem;
}

.contact-info-card p {
  font-size: 1rem;
  color: var(--color-primary);
  margin: 0.25rem 0;
  font-weight: 500;
}

.contact-hint {
  display: block;
  font-size: 0.85rem;
  color: var(--color-secondary);
  margin-top: 0.75rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.contact-info-card:hover .contact-hint {
  opacity: 1;
}

.modal-footer {
  padding: 2rem 3rem 3rem;
  text-align: center;
  background: linear-gradient(to bottom, #fff 0%, var(--color-neutral) 100%);
  border-top: 1px solid rgba(55, 65, 81, 0.1);
}

.modal-footer p {
  color: var(--color-primary);
  font-size: 0.95rem;
  margin: 0;
  font-style: italic;
}

/* Responsive */
@media (max-width: 640px) {
  .contact-modal {
    border-radius: 1rem;
    max-height: 95vh;
  }

  .modal-header {
    padding: 2.5rem 2rem 1.5rem;
  }

  .modal-header h2 {
    font-size: 1.5rem;
  }

  .modal-form {
    padding: 1.5rem 2rem;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .modal-contact-info {
    padding: 1.5rem 2rem 2.5rem;
  }

  .modal-contact-info-large {
    padding: 1.5rem 2rem 2.5rem;
    grid-template-columns: 1fr;
  }

  .modal-footer {
    padding: 1.5rem 2rem 2.5rem;
  }

  .modal-close {
    top: 1rem;
    right: 1rem;
    width: 36px;
    height: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/contact-modal.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0EAA0E;EAC1E,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,uEAAuE;EACvE,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0EAA0E;EAC1E,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[":root {\n  --color-primary: #000000;\n  --color-secondary: #000000;\n  --color-accent: #ffffff;\n  --color-neutral: #ffffff;\n  --color-text: #000000;\n}\n\n.contact-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 1rem;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.contact-modal {\n  background: white;\n  border-radius: 1.5rem;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n.contact-modal-simple {\n  max-width: 700px;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-close {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  background: rgba(0, 0, 0, 0.05);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--color-text);\n  z-index: 10;\n}\n\n.modal-close:hover {\n  background: rgba(0, 0, 0, 0.1);\n  transform: rotate(90deg);\n}\n\n.modal-header {\n  padding: 3rem 3rem 2rem;\n  text-align: center;\n  background: linear-gradient(135deg, var(--color-neutral) 0%, #fff 100%);\n}\n\n.modal-header h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--color-text);\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.01em;\n}\n\n.modal-header p {\n  color: var(--color-primary);\n  font-size: 1rem;\n  opacity: 0.9;\n}\n\n.modal-form {\n  padding: 2rem 3rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: var(--color-text);\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  border: 2px solid rgba(55, 65, 81, 0.15);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--color-secondary);\n  box-shadow: 0 0 0 3px rgba(170, 97, 58, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.submit-success {\n  background: #10b981;\n  color: white;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.submit-error {\n  background: #ef4444;\n  color: white;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.modal-submit-btn {\n  width: 100%;\n  background: var(--color-secondary);\n  color: var(--color-neutral);\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  letter-spacing: 0.02em;\n}\n\n.modal-submit-btn:hover:not(:disabled) {\n  background: var(--color-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(55, 65, 81, 0.25);\n}\n\n.modal-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.modal-contact-info {\n  padding: 2rem 3rem 3rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background: linear-gradient(to bottom, #fff 0%, var(--color-neutral) 100%);\n  border-top: 1px solid rgba(55, 65, 81, 0.1);\n}\n\n.contact-info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--color-primary);\n  font-size: 0.95rem;\n}\n\n.contact-info-item svg {\n  color: var(--color-secondary);\n  flex-shrink: 0;\n}\n\n.modal-contact-info-large {\n  padding: 2rem 3rem 3rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n}\n\n.contact-info-card {\n  background: linear-gradient(135deg, var(--color-neutral) 0%, #fff 100%);\n  border: 2px solid rgba(55, 65, 81, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 1.5rem;\n  text-align: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.contact-info-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(55, 65, 81, 0.15);\n  border-color: var(--color-secondary);\n}\n\n.contact-info-card:last-child {\n  cursor: default;\n}\n\n.contact-info-card:last-child:hover {\n  transform: none;\n}\n\n.contact-icon-large {\n  width: 70px;\n  height: 70px;\n  background: var(--color-secondary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.25rem;\n  transition: all 0.3s ease;\n}\n\n.contact-info-card:hover .contact-icon-large {\n  background: var(--color-primary);\n  transform: scale(1.1);\n}\n\n.contact-info-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-text);\n  margin-bottom: 0.75rem;\n}\n\n.contact-info-card p {\n  font-size: 1rem;\n  color: var(--color-primary);\n  margin: 0.25rem 0;\n  font-weight: 500;\n}\n\n.contact-hint {\n  display: block;\n  font-size: 0.85rem;\n  color: var(--color-secondary);\n  margin-top: 0.75rem;\n  font-weight: 600;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.contact-info-card:hover .contact-hint {\n  opacity: 1;\n}\n\n.modal-footer {\n  padding: 2rem 3rem 3rem;\n  text-align: center;\n  background: linear-gradient(to bottom, #fff 0%, var(--color-neutral) 100%);\n  border-top: 1px solid rgba(55, 65, 81, 0.1);\n}\n\n.modal-footer p {\n  color: var(--color-primary);\n  font-size: 0.95rem;\n  margin: 0;\n  font-style: italic;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .contact-modal {\n    border-radius: 1rem;\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 2.5rem 2rem 1.5rem;\n  }\n\n  .modal-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .modal-form {\n    padding: 1.5rem 2rem;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .modal-contact-info {\n    padding: 1.5rem 2rem 2.5rem;\n  }\n\n  .modal-contact-info-large {\n    padding: 1.5rem 2rem 2.5rem;\n    grid-template-columns: 1fr;\n  }\n\n  .modal-footer {\n    padding: 1.5rem 2rem 2.5rem;\n  }\n\n  .modal-close {\n    top: 1rem;\n    right: 1rem;\n    width: 36px;\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
